export default "__VITE_ASSET__p_KiBjGt__"